import { Ref } from '@nejcm/docz-theme-extended';
import * as React from 'react';
export default {
  Ref,
  React
};